export default __webpack_public_path__ + "static/media/20.289cbb5d.jpg";